var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('sub-visual', {
    attrs: {
      "subTabNone": "",
      "sh": "이메일 무단수집거부",
      "bg": "/images/sub/visual/sv6.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('terms-component', {
    attrs: {
      "code": "email"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }